// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Tagging Section Styles */
.profile-tagging-container {
  width: 100%;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
}

.profile-selected-tags-section {
  margin-bottom: 15px;
  padding: 15px;
  /* background: #fafbfc;
  border: 2px solid #e9ecef;
  border-radius: 12px; */
  transition: border-color 0.2s ease;
}

.profile-selected-tags-title {
  font-weight: 600;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.profile-selected-tags-title::before {
  content: "✓";
  background: #28a745;
  color: white;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: bold;
}

.profile-selected-tags-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 10px;
}

.profile-available-tags-section {
  padding: 15px;
  max-height: 400px;
  overflow-y: auto;
  margin-bottom: 15px;
  transition: border-color 0.2s ease;
}

.profile-available-tags-section:hover,
.profile-selected-tags-section:hover {
  border-color: #dee2e6;
}

.profile-available-tags-title {
  font-weight: 600;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.profile-available-tags-title::before {
  content: "🏷️";
  font-size: 16px;
}

.profile-category-section {
  margin-bottom: 15px;
}

.profile-category-title {
  font-weight: 600;
  margin-bottom: 8px;
  padding-bottom: 4px;
  letter-spacing: 0.5px;
}

.profile-category-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

/* Tag Pills */
.profile-tag-pill {
  display: inline-flex;
  align-items: center;
  padding: 5px 10px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  user-select: none;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  border: 2px solid transparent;
  position: relative;
  overflow: hidden;
}

.profile-tag-pill::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
  transition: left 0.5s;
}

.profile-tag-pill:hover::before {
  left: 100%;
}

.profile-tag-pill-approved {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  color: #495057;
  border-color: #dee2e6;
}

.profile-tag-pill-approved:hover {
  background: linear-gradient(135deg, #e9ecef 0%, #dee2e6 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.profile-tag-pill-selected {
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%) !important;
  color: white !important;
  border-color: #28a745 !important;
  box-shadow: 0 4px 12px rgba(40, 167, 69, 0.3);
}

.profile-tag-pill-selected:hover {
  background: linear-gradient(135deg, #218838 0%, #1ea085 100%) !important;
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(40, 167, 69, 0.4);
}

/* .profile-tag-pill-proposed {
  background: linear-gradient(135deg, #fff3cd 0%, #ffeaa7 100%);
  color: #856404;
  border-color: #ffeaa7;
} */

/* .profile-tag-category {
  font-weight: 700;
  font-size: 10px;
  margin-right: 4px;
  opacity: 0.8;
  text-transform: uppercase;
  letter-spacing: 0.3px;
} */

/* Adjustments for proposed tag category visibility */
/* .profile-tag-pill-proposed .profile-tag-category {
  color: #5a4600; 
  opacity: 1; 
} */

.profile-tag-pending {
  margin-left: 4px;
  font-size: 10px;
  opacity: 0.7;
  font-style: italic;
}

/* Proposed Tags Section */
.profile-proposed-tags-section {
  margin-bottom: 15px;
  padding: 15px;
}

.profile-proposed-tags-title {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.profile-proposed-tags-title::before {
  content: "⏳";
  font-size: 14px;
}

.profile-proposed-tag-item {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  gap: 12px;
}

.profile-remove-button {
  padding: 4px 8px;
  background: linear-gradient(135deg, #dc3545 0%, #c82333 100%);
  color: white;
  border: none;
  border-radius: 15px;
  cursor: pointer;
  font-size: 11px;
  font-weight: 600;
  transition: all 0.2s ease;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.profile-remove-button:hover {
  background: linear-gradient(135deg, #c82333 0%, #a71e2a 100%);
  transform: scale(1.05);
}

/* New Tag Form */
.profile-new-tag-section {
  margin-bottom: 15px;
  padding: 15px;
}

.profile-new-tag-section.hidden {
  display: none;
}

.profile-new-tag-title {
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.profile-new-tag-title::before {
  content: "✨";
  font-size: 14px;
}

/* Adjusted grid for new tag form */
.profile-new-tag-form {
  display: grid;
  grid-template-columns: 1fr; /* Stack elements on smaller screens by default */
  gap: 15px; /* Increased gap for better spacing */
  align-items: start; /* Align items to the start of their cells */
  margin-bottom: 12px;
}

@media (min-width: 768px) {
  .profile-new-tag-form {
    grid-template-columns: 1fr 1fr; /* Two columns on larger screens */
    /* Remove 'auto' column, let button take its own space or span */
  }

  .profile-input-group-full-width {
    grid-column: 1 / -1; /* Make tag name span full width on larger screens */
  }

  .profile-add-button-container {
    grid-column: 1 / -1; /* Make add button span full width to center it */
    display: flex; /* Use flex to center the button */
    justify-content: center; /* Center the button horizontally */
    margin-top: 10px; /* Add some space above the button */
  }
}

.profile-input-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.profile-text-input,
.profile-select-input {
  padding: 8px 10px;
  transition: all 0.2s ease;
  width: 100%; /* Ensure inputs take full width of their grid cell */
  box-sizing: border-box; /* Include padding and border in the element's total width and height */
}

/* IMPORTANT CHANGE FOR PLACEHOLDER TEXT */
.profile-text-input::placeholder,
.profile-textarea-input::placeholder,
.profile-select-input {
  opacity: 1; /* Ensure full opacity */
}

.profile-text-input:focus,
.profile-select-input:focus {
  outline: none;
  border-color: #74b9ff;
  box-shadow: 0 0 0 3px rgba(116, 185, 255, 0.2);
}

.profile-textarea-input {
  width: 100%;
  padding: 8px 10px;
  min-height: 60px;
  resize: vertical;
  font-family: inherit;
  transition: all 0.2s ease;
  box-sizing: border-box; /* Include padding and border in the element's total width and height */
}

.profile-textarea-input:focus {
  outline: none;
  border-color: #74b9ff;
  box-shadow: 0 0 0 3px rgba(116, 185, 255, 0.2);
}

.profile-add-button:hover {
  background: linear-gradient(135deg, #00a085 0%, #008f72 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 184, 148, 0.4);
}

/* Toggle button for new tag form */
.profile-new-tag-toggle {
  margin-bottom: 15px;
  text-align: center;
}

/* Loading State */
.profile-loading-container {
  margin: 20px 0;
}

.profile-loading-container::before {
  content: "⏳";
  display: block;
  margin-bottom: 8px;
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}

.profile-empty-state {
  color: #6c757d;
  font-style: italic;
  text-align: center;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 8px;
  margin: 12px 0;
}

/* Responsive Design */
@media (max-width: 767px) {
  /* Adjusted breakpoint for mobile */
  .profile-new-tag-form {
    grid-template-columns: 1fr; /* Ensure single column layout on smaller screens */
    gap: 10px;
  }

  .profile-category-tags,
  .profile-selected-tags-grid {
    gap: 4px;
  }

  .profile-tag-pill {
    font-size: 11px;
    padding: 4px 8px;
  }

  .profile-add-button-container {
    margin-top: 0; /* Remove top margin on mobile if stacked */
  }
}

.styled-placeholder::placeholder {
  opacity: 0.4;
  font-style: italic;
}

/* Firefox specific placeholder styling */
.styled-placeholder::-moz-placeholder {
  opacity: 0.4;
  font-style: italic;
}

/* Webkit browsers (Chrome, Safari, etc.) */
.styled-placeholder::-webkit-input-placeholder {
  opacity: 0.4;
  font-style: italic;
}

/* Microsoft Edge */
.styled-placeholder::-ms-input-placeholder {
  opacity: 0.4;
  font-style: italic;
}
`, "",{"version":3,"sources":["webpack://./app/javascript/react/components/exhibitorProfile/ProfileForm.css"],"names":[],"mappings":"AAAA,2BAA2B;AAC3B;EACE,WAAW;EACX,8EAA8E;AAChF;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb;;wBAEsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA,cAAc;AACd;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iDAAiD;EACjD,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,sFAAsF;EACtF,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,wEAAwE;EACxE,uBAAuB;EACvB,gCAAgC;EAChC,6CAA6C;AAC/C;;AAEA;EACE,wEAAwE;EACxE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;;;;GAIG;;AAEH;;;;;;;GAOG;;AAEH,qDAAqD;AACrD;;;GAGG;;AAEH;EACE,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA,0BAA0B;AAC1B;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,6DAA6D;EAC7D,sBAAsB;AACxB;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,0BAA0B,EAAE,iDAAiD;EAC7E,SAAS,EAAE,qCAAqC;EAChD,kBAAkB,EAAE,4CAA4C;EAChE,mBAAmB;AACrB;;AAEA;EACE;IACE,8BAA8B,EAAE,kCAAkC;IAClE,gEAAgE;EAClE;;EAEA;IACE,mBAAmB,EAAE,oDAAoD;EAC3E;;EAEA;IACE,mBAAmB,EAAE,iDAAiD;IACtE,aAAa,EAAE,kCAAkC;IACjD,uBAAuB,EAAE,mCAAmC;IAC5D,gBAAgB,EAAE,oCAAoC;EACxD;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;;EAEE,iBAAiB;EACjB,yBAAyB;EACzB,WAAW,EAAE,qDAAqD;EAClE,sBAAsB,EAAE,uEAAuE;AACjG;;AAEA,0CAA0C;AAC1C;;;EAGE,UAAU,EAAE,wBAAwB;AACtC;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,yBAAyB;EACzB,sBAAsB,EAAE,uEAAuE;AACjG;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA,mCAAmC;AACnC;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE;;IAEE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,mCAAmC;EACnC;IACE,0BAA0B,EAAE,mDAAmD;IAC/E,SAAS;EACX;;EAEA;;IAEE,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,aAAa,EAAE,2CAA2C;EAC5D;AACF;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA,yCAAyC;AACzC;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA,2CAA2C;AAC3C;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,YAAY;EACZ,kBAAkB;AACpB","sourcesContent":["/* Tagging Section Styles */\n.profile-tagging-container {\n  width: 100%;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif;\n}\n\n.profile-selected-tags-section {\n  margin-bottom: 15px;\n  padding: 15px;\n  /* background: #fafbfc;\n  border: 2px solid #e9ecef;\n  border-radius: 12px; */\n  transition: border-color 0.2s ease;\n}\n\n.profile-selected-tags-title {\n  font-weight: 600;\n  margin-bottom: 10px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.profile-selected-tags-title::before {\n  content: \"✓\";\n  background: #28a745;\n  color: white;\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 10px;\n  font-weight: bold;\n}\n\n.profile-selected-tags-grid {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-top: 10px;\n}\n\n.profile-available-tags-section {\n  padding: 15px;\n  max-height: 400px;\n  overflow-y: auto;\n  margin-bottom: 15px;\n  transition: border-color 0.2s ease;\n}\n\n.profile-available-tags-section:hover,\n.profile-selected-tags-section:hover {\n  border-color: #dee2e6;\n}\n\n.profile-available-tags-title {\n  font-weight: 600;\n  margin-bottom: 12px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.profile-available-tags-title::before {\n  content: \"🏷️\";\n  font-size: 16px;\n}\n\n.profile-category-section {\n  margin-bottom: 15px;\n}\n\n.profile-category-title {\n  font-weight: 600;\n  margin-bottom: 8px;\n  padding-bottom: 4px;\n  letter-spacing: 0.5px;\n}\n\n.profile-category-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n/* Tag Pills */\n.profile-tag-pill {\n  display: inline-flex;\n  align-items: center;\n  padding: 5px 10px;\n  border-radius: 16px;\n  font-size: 12px;\n  font-weight: 500;\n  cursor: pointer;\n  user-select: none;\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  border: 2px solid transparent;\n  position: relative;\n  overflow: hidden;\n}\n\n.profile-tag-pill::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);\n  transition: left 0.5s;\n}\n\n.profile-tag-pill:hover::before {\n  left: 100%;\n}\n\n.profile-tag-pill-approved {\n  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);\n  color: #495057;\n  border-color: #dee2e6;\n}\n\n.profile-tag-pill-approved:hover {\n  background: linear-gradient(135deg, #e9ecef 0%, #dee2e6 100%);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n.profile-tag-pill-selected {\n  background: linear-gradient(135deg, #28a745 0%, #20c997 100%) !important;\n  color: white !important;\n  border-color: #28a745 !important;\n  box-shadow: 0 4px 12px rgba(40, 167, 69, 0.3);\n}\n\n.profile-tag-pill-selected:hover {\n  background: linear-gradient(135deg, #218838 0%, #1ea085 100%) !important;\n  transform: translateY(-1px);\n  box-shadow: 0 6px 16px rgba(40, 167, 69, 0.4);\n}\n\n/* .profile-tag-pill-proposed {\n  background: linear-gradient(135deg, #fff3cd 0%, #ffeaa7 100%);\n  color: #856404;\n  border-color: #ffeaa7;\n} */\n\n/* .profile-tag-category {\n  font-weight: 700;\n  font-size: 10px;\n  margin-right: 4px;\n  opacity: 0.8;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n} */\n\n/* Adjustments for proposed tag category visibility */\n/* .profile-tag-pill-proposed .profile-tag-category {\n  color: #5a4600; \n  opacity: 1; \n} */\n\n.profile-tag-pending {\n  margin-left: 4px;\n  font-size: 10px;\n  opacity: 0.7;\n  font-style: italic;\n}\n\n/* Proposed Tags Section */\n.profile-proposed-tags-section {\n  margin-bottom: 15px;\n  padding: 15px;\n}\n\n.profile-proposed-tags-title {\n  margin-bottom: 10px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.profile-proposed-tags-title::before {\n  content: \"⏳\";\n  font-size: 14px;\n}\n\n.profile-proposed-tag-item {\n  display: flex;\n  align-items: center;\n  margin-bottom: 8px;\n  gap: 12px;\n}\n\n.profile-remove-button {\n  padding: 4px 8px;\n  background: linear-gradient(135deg, #dc3545 0%, #c82333 100%);\n  color: white;\n  border: none;\n  border-radius: 15px;\n  cursor: pointer;\n  font-size: 11px;\n  font-weight: 600;\n  transition: all 0.2s ease;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n}\n\n.profile-remove-button:hover {\n  background: linear-gradient(135deg, #c82333 0%, #a71e2a 100%);\n  transform: scale(1.05);\n}\n\n/* New Tag Form */\n.profile-new-tag-section {\n  margin-bottom: 15px;\n  padding: 15px;\n}\n\n.profile-new-tag-section.hidden {\n  display: none;\n}\n\n.profile-new-tag-title {\n  margin-bottom: 12px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.profile-new-tag-title::before {\n  content: \"✨\";\n  font-size: 14px;\n}\n\n/* Adjusted grid for new tag form */\n.profile-new-tag-form {\n  display: grid;\n  grid-template-columns: 1fr; /* Stack elements on smaller screens by default */\n  gap: 15px; /* Increased gap for better spacing */\n  align-items: start; /* Align items to the start of their cells */\n  margin-bottom: 12px;\n}\n\n@media (min-width: 768px) {\n  .profile-new-tag-form {\n    grid-template-columns: 1fr 1fr; /* Two columns on larger screens */\n    /* Remove 'auto' column, let button take its own space or span */\n  }\n\n  .profile-input-group-full-width {\n    grid-column: 1 / -1; /* Make tag name span full width on larger screens */\n  }\n\n  .profile-add-button-container {\n    grid-column: 1 / -1; /* Make add button span full width to center it */\n    display: flex; /* Use flex to center the button */\n    justify-content: center; /* Center the button horizontally */\n    margin-top: 10px; /* Add some space above the button */\n  }\n}\n\n.profile-input-group {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.profile-text-input,\n.profile-select-input {\n  padding: 8px 10px;\n  transition: all 0.2s ease;\n  width: 100%; /* Ensure inputs take full width of their grid cell */\n  box-sizing: border-box; /* Include padding and border in the element's total width and height */\n}\n\n/* IMPORTANT CHANGE FOR PLACEHOLDER TEXT */\n.profile-text-input::placeholder,\n.profile-textarea-input::placeholder,\n.profile-select-input {\n  opacity: 1; /* Ensure full opacity */\n}\n\n.profile-text-input:focus,\n.profile-select-input:focus {\n  outline: none;\n  border-color: #74b9ff;\n  box-shadow: 0 0 0 3px rgba(116, 185, 255, 0.2);\n}\n\n.profile-textarea-input {\n  width: 100%;\n  padding: 8px 10px;\n  min-height: 60px;\n  resize: vertical;\n  font-family: inherit;\n  transition: all 0.2s ease;\n  box-sizing: border-box; /* Include padding and border in the element's total width and height */\n}\n\n.profile-textarea-input:focus {\n  outline: none;\n  border-color: #74b9ff;\n  box-shadow: 0 0 0 3px rgba(116, 185, 255, 0.2);\n}\n\n.profile-add-button:hover {\n  background: linear-gradient(135deg, #00a085 0%, #008f72 100%);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(0, 184, 148, 0.4);\n}\n\n/* Toggle button for new tag form */\n.profile-new-tag-toggle {\n  margin-bottom: 15px;\n  text-align: center;\n}\n\n/* Loading State */\n.profile-loading-container {\n  margin: 20px 0;\n}\n\n.profile-loading-container::before {\n  content: \"⏳\";\n  display: block;\n  margin-bottom: 8px;\n  animation: pulse 2s infinite;\n}\n\n@keyframes pulse {\n  0%,\n  100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.5;\n  }\n}\n\n.profile-empty-state {\n  color: #6c757d;\n  font-style: italic;\n  text-align: center;\n  padding: 20px;\n  background: #f8f9fa;\n  border-radius: 8px;\n  margin: 12px 0;\n}\n\n/* Responsive Design */\n@media (max-width: 767px) {\n  /* Adjusted breakpoint for mobile */\n  .profile-new-tag-form {\n    grid-template-columns: 1fr; /* Ensure single column layout on smaller screens */\n    gap: 10px;\n  }\n\n  .profile-category-tags,\n  .profile-selected-tags-grid {\n    gap: 4px;\n  }\n\n  .profile-tag-pill {\n    font-size: 11px;\n    padding: 4px 8px;\n  }\n\n  .profile-add-button-container {\n    margin-top: 0; /* Remove top margin on mobile if stacked */\n  }\n}\n\n.styled-placeholder::placeholder {\n  opacity: 0.4;\n  font-style: italic;\n}\n\n/* Firefox specific placeholder styling */\n.styled-placeholder::-moz-placeholder {\n  opacity: 0.4;\n  font-style: italic;\n}\n\n/* Webkit browsers (Chrome, Safari, etc.) */\n.styled-placeholder::-webkit-input-placeholder {\n  opacity: 0.4;\n  font-style: italic;\n}\n\n/* Microsoft Edge */\n.styled-placeholder::-ms-input-placeholder {\n  opacity: 0.4;\n  font-style: italic;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
